import { Component, OnInit, Inject } from '@angular/core';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl, FormArray } from '@angular/forms';
import {
  MdInputModule, MdRadioModule, MdDialog, MdDialogRef,
  MD_DIALOG_DATA, MdSelectModule, MdRadioButton, MdDatepickerInputEvent
} from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../../shared/services/validation.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';

import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { RequestAppointmentModel } from '../../../models/booking/request-appointment.model';
import { RequestAppointmentService } from './request-appointment.service';
import { PartyType } from '../../../models/consultation/cash-sale.model';
import { BookingDetailsModel } from '../../../models/booking/booking-details.model';
import { BaseService } from '../../../shared/services/base.service';
import { BookingUrl } from '../../../shared/urls/booking.url';
import * as moment from 'moment';
import { ValidationErrors } from '@angular/forms/src/directives/validators';

@Component({
  selector: 'request-appointment',
  templateUrl: './request-appointment.component.html',
  providers: [RequestAppointmentService]
})
export class RequestAppointmentComponent implements OnInit {
  panelMaxHeight = new FormControl('mh-dropdown');
  public partyType = PartyType;
  public isAddSuccess = false;
  public requestAppointmentForm: FormGroup;
  public requestAppointmentModel = new BookingDetailsModel();
  public centreName: string;
  public tripCountries = new Array();
  public errorPattern = {
    tripCountries: 0
  };
  public countriesOption: Array<any> = [];
  public centres = [];
  public clinics = [];

  // generate time length
  public startHour: Array<any> = [];
  public startMinutes: Array<any> = [];
  public endHour: Array<any> = [];
  public endMinutes: Array<any> = [];

  public bookingTypeData = [];
  public reasonTripData = [];
  // public reasonData = []; // Feature CR06
  public typeAccommodationData = [];
  public countryData = [];
  public paymentTermData = [];
  public durationData = [];
  public booking: number;
  public destinationTypes: any[];
  public bookingMemberModel = new BookingDetailsModel();
  public minDate = new Date();
  public maxDate = new Date();
  public closedMaxDate = new Date();

  public timeModel = {
    startMinutes: '',
    startHour: '',
    endMinutes: '',
    endHour: ''
  };

  public closedTimeModel = {
    startMinutes: '',
    startHour: '',
    endMinutes: '',
    endHour: ''
  };
  public disableList = [];

  public destinationArr = [];
  public submitted = false;

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private formBuilder: FormBuilder,
    public utility: Utility,
    public dialogService: DialogService,
    public baseService: BaseService,
    private requestAppointmentService: RequestAppointmentService) {

    // Set min max day for calendar
    const date = new Date();
    date.setHours(0, 0, 0);
    this.minDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());

    date.setHours(23, 59, 59);
    this.maxDate.setFullYear(date.getFullYear(), date.getMonth() + 1, date.getDate());
    this.closedMaxDate.setFullYear(date.getFullYear() + 1, date.getMonth(), date.getDate());
    this.disableList = this.requestAppointmentService.getDisableList();
    // Create form booking
    this.createForm();
  }

  setModel(bookingdata) {
    if (bookingdata) {
      if (bookingdata.bookingType) {
        this.booking = bookingdata.bookingType;
        this.requestAppointmentForm.controls['bookingType'].setValue(bookingdata.bookingType);
      }
      const timeZone = (-1) * new Date().getTimezoneOffset() / 60;
      const departDate = moment(bookingdata.departDate).toDate();
      if (moment.isDate(departDate)) {
        this.requestAppointmentForm.controls['departDate'].setValue(departDate);
      }
      const adminDate = moment(bookingdata.administeredDate).toDate();
      if (moment.isDate(adminDate)) {
        this.requestAppointmentForm.controls['administeredDate'].setValue(adminDate);
      }
      const returnDate = moment(bookingdata.returnDate).toDate();
      if (moment.isDate(returnDate)) {
        this.requestAppointmentForm.controls['returnDate'].setValue(returnDate);
      }
      if (moment.isDate(moment(bookingdata.startTime).toDate())) {
        const fromTime = moment(bookingdata.startTime).toObject();
        let startHour = (fromTime.hours + timeZone) > 9 ?
          (fromTime.hours + timeZone).toString() : '0' + (fromTime.hours + timeZone).toString();
        startHour = parseInt(startHour, 0) > 23 ?
          ((parseInt(startHour, 0) % 24) > 9 ? (parseInt(startHour, 0) % 24).toString()
            : '0' + (parseInt(startHour, 0) % 24).toString()) : startHour;
        this.timeModel.startHour = startHour;
        this.timeModel.startMinutes = fromTime.minutes >= 10 ? fromTime.minutes.toString() : '0' + fromTime.minutes.toString();
        this.requestAppointmentForm.controls['fromTime'].setValue(moment(bookingdata.startTime).format());
      }
      if (moment.isDate(moment(bookingdata.endTime).toDate())) {
        const toTime = moment(bookingdata.endTime).toObject();
        let endHour = (toTime.hours + timeZone) > 9 ?
          (toTime.hours + timeZone).toString() : '0' + (toTime.hours + timeZone).toString();
        endHour = parseInt(endHour, 0) > 23 ?
          ((parseInt(endHour, 0) % 24) > 9 ? (parseInt(endHour, 0) % 24).toString()
            : '0' + (parseInt(endHour, 0) % 24).toString()) : endHour;
        this.timeModel.endHour = endHour;
        this.timeModel.endMinutes = toTime.minutes >= 10 ? toTime.minutes.toString() : '0' + toTime.minutes.toString();
        this.requestAppointmentForm.controls['toTime'].setValue(moment(bookingdata.endTime).format());
      }
      if (bookingdata.reasonTrip) {
        this.requestAppointmentForm.controls['reasonTrip'].setValue(bookingdata.reasonTrip);
      }
      if (bookingdata.typeAccommodation) {
        this.requestAppointmentForm.controls['typeAccommodation'].setValue(bookingdata.typeAccommodation);
      }
      if (bookingdata.travelDestination) {
        // this.requestAppointmentModel.travelDestination = [];
        this.tripCountries = bookingdata.travelDestination;
        bookingdata.travelDestinationId = new Array();
        const newArr = [];
        let i = 0;
        while (i < bookingdata.travelDestination.length) {
          const data = this.countryData.find(x => x.id === bookingdata.travelDestination[i].id);
          if (data) {
            newArr.push(data);
          }
          bookingdata.travelDestinationId.push(bookingdata.travelDestination[i].destinationTypeId);
          i++;
        }
        this.requestAppointmentModel.travelDestination = newArr;
        this.requestAppointmentForm.controls['travelDestination'].setValue(newArr);
      }
      if (bookingdata.groupName) {
        // this.requestAppointmentForm.controls['groupName'].setValue(bookingdata.groupName);
        this.requestAppointmentModel.groupName = bookingdata.groupName;
      }
      if (bookingdata.note) {
        this.requestAppointmentForm.controls['note'].setValue(bookingdata.note);
      }
      if (bookingdata.duration) {
        // this.requestAppointmentForm.controls['duration'].setValue(bookingdata.duration);
        this.requestAppointmentModel.duration = bookingdata.duration;
      }
      if (bookingdata.paymentTerm) {
        // this.requestAppointmentForm.controls['paymentTerm'].setValue(bookingdata.paymentTerm);
        this.requestAppointmentModel.paymentTerm = bookingdata.paymentTerm;
      }
    }
  }

  isValidDate(str: string) {
    const d = moment(str, 'D/M/YYYY');
    if (d === null || !d.isValid()) { return false; }
    return str.indexOf(d.format('D/M/YYYY')) >= 0
      || str.indexOf(d.format('DD/MM/YYYY')) >= 0
      || str.indexOf(d.format('D/M/YY')) >= 0
      || str.indexOf(d.format('DD/MM/YY')) >= 0;
  }

  ngOnInit() {
    this.centreName = localStorage.getItem(AppConstants.localStorage.centreName);
    this.requestAppointmentService.getAllClinic(localStorage.getItem(AppConstants.localStorage.centreId)).subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.clinics = data['list'];
        }
      }
    );
    this.initData(callback => {
      if (callback) {
        this.getCountryData(call => {
          if (call) {
            this.requestAppointmentService.getBookingCache().subscribe(
              (result) => {
                if (result) {
                  const data = result.json();
                  if (data) {
                    this.setModel(data);
                    if (data.listMembers) {
                      if (data.listMembers.length !== 0) {
                        this.requestAppointmentModel.listMembers = data.listMembers;
                      }
                    }
                    if (data.staffs) {
                      if (data.staffs.length !== 0) {
                        this.requestAppointmentModel.staffs = data.staffs;
                      }
                    }
                  }
                }
              }
            );
          }
        });
      }
    });
    this.requestAppointmentModel.centreId = this.centreName;
    this.requestAppointmentForm.controls['bookingType'].valueChanges.subscribe(value => {
      const paymentTermCtrl = <FormControl>this.requestAppointmentForm.controls['paymentTerm'];
      if (parseInt(value, 0) === PartyType.Individual) {
        paymentTermCtrl.disable();
        this.setValidatorType(false, this.requestAppointmentForm.controls['groupName']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['paymentTerm']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['administeredDate']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['duration']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['fromTime']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['toTime']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedDate']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedFromTime']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedToTime'], 'custom');
        this.setValidatorType(true, this.requestAppointmentForm.controls['reasonTrip']);
        this.setValidatorType(true, this.requestAppointmentForm.controls['typeAccommodation']);
        this.setValidatorType(true, this.requestAppointmentForm.controls['travelDestination']);
      } else if (parseInt(value, 0) === PartyType.Group) {
        paymentTermCtrl.enable();
        this.setValidatorType(true, this.requestAppointmentForm.controls['groupName'], 'specialchar');
        this.setValidatorType(true, this.requestAppointmentForm.controls['paymentTerm']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['administeredDate']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['duration']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['fromTime']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['toTime']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedDate']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedFromTime']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedToTime'], 'custom');
        this.setValidatorType(true, this.requestAppointmentForm.controls['reasonTrip']);
        this.setValidatorType(true, this.requestAppointmentForm.controls['typeAccommodation']);
        this.setValidatorType(true, this.requestAppointmentForm.controls['travelDestination']);
        this.requestAppointmentModel.paymentTerm = '';
        this.requestAppointmentForm.controls['paymentTerm'].setValue('');
      } else if (parseInt(value, 0) === PartyType.FluVaccine) {
        paymentTermCtrl.disable();
        this.setValidatorType(true, this.requestAppointmentForm.controls['groupName'], 'specialchar');
        this.setValidatorType(true, this.requestAppointmentForm.controls['paymentTerm']);
        this.setValidatorType(true, this.requestAppointmentForm.controls['administeredDate'], 'minandmaxdate');
        this.setValidatorType(true, this.requestAppointmentForm.controls['duration']);
        this.setValidatorType(true, this.requestAppointmentForm.controls['fromTime'], 'validatehour');
        this.setValidatorType(true, this.requestAppointmentForm.controls['toTime'], 'custom');
        this.setValidatorType(false, this.requestAppointmentForm.controls['reasonTrip']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['typeAccommodation']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['travelDestination']);
        this.requestAppointmentForm.controls['paymentTerm'].setValue('30 days from invoices date');
        this.requestAppointmentModel.paymentTerm = '30 days from invoices date';
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedDate']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedFromTime']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['closedToTime'], 'custom');
      } else if (parseInt(value, 0) === PartyType.Blocked) {
        paymentTermCtrl.disable();
        this.setValidatorType(false, this.requestAppointmentForm.controls['groupName'], 'specialchar');
        this.setValidatorType(false, this.requestAppointmentForm.controls['paymentTerm']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['administeredDate']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['duration']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['reasonTrip']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['typeAccommodation']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['travelDestination']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['fromTime']);
        this.setValidatorType(false, this.requestAppointmentForm.controls['toTime'], 'custom');
        this.setValidatorType(true, this.requestAppointmentForm.controls['closedDate']);
        this.setValidatorType(true, this.requestAppointmentForm.controls['closedFromTime']);
        this.setValidatorType(true, this.requestAppointmentForm.controls['closedToTime'], 'custom');
      }

    });
    this.requestAppointmentForm.controls['duration'].valueChanges.subscribe(value => {
      if (value && this.timeModel.startHour && this.timeModel.startHour) {
        this.requestAppointmentForm.controls['toTime'].updateValueAndValidity();
      }
    });
  }

  createForm() {
    this.requestAppointmentForm = this.formBuilder.group({
      bookingType: ['', [Validators.required]],
      centreId: [localStorage.getItem(AppConstants.localStorage.centreId)],
      centre: [localStorage.getItem(AppConstants.localStorage.centreName)],
      // clinicId: [null, [Validators.required]],
      departDate: [new Date(), [Validators.required]],
      returnDate: [new Date(), [Validators.required]],
      typeAccommodation: ['', [Validators.required]],
      travelDestination: ['', [Validators.required]],
      reasonTrip: ['', [Validators.required]],
      // reason: [''], // Feature CR06
      note: [''],
      // Group form
      groupName: [''],
      paymentTerm: [''],
      listMembers: [''],
      staffs: [''],
      // Flu vaccine
      destination: [''],
      administeredDate: [new Date()],
      duration: [null],
      fromTime: [''],
      toTime: [''],
      startHour: [''],
      startMinutes: [''],
      endHour: [''],
      endMinutes: [''],
      isChangeType: [''],
      // Blocked
      closedDate: [new Date()],
      closedFromTime: [''],
      closedToTime: [''],
      isSaveFluBooking: ['']
    });
  }

  checkValue(val: any) {
    if (val) {
      const isNan = parseInt(val.toString(), 0);
      if (isNaN(isNan)) {
        return false;
      }
      return true;
    }
    return false;
  }

  initData(callback?) {
    this.requestAppointmentService.getInit().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.reasonTripData = data['tripReason'];
          this.typeAccommodationData = data['accommodationTypes'];
          this.paymentTermData = data['paymentTerm'];
          if (this.paymentTermData.findIndex(x => x.toLocaleLowerCase() === '30 days from invoices date') < 0) {
            this.paymentTermData.push('30 days from invoices date');
          }
          this.durationData = data['duration'];
          this.bookingTypeData = data['bookingTypes'];
          this.destinationTypes = data['destinationTypes'];
        }
        callback(true);
      }, error => { callback(true); }
    );

    // Feature CR06
    // Data test. Should push in this.requestAppointmentService.getInit()
    // this.reasonData = [
    //   { id: 'ao388', name: 'Test 1', colour: '#000000', isActive: true },
    //   { id: 'ao389', name: 'Test 2', colour: '#ffffff', isActive: false },
    //   { id: 'ao384', name: 'Test 3', colour: '#ffffff', isActive: true },
    //   { id: 'ao382', name: 'Test 4', colour: '#cccccc', isActive: false },
    // ];

    this.startHour = AppConstants.bookingHours;
    this.startMinutes = AppConstants.bookingMinutes;
    this.endHour = AppConstants.bookingHours;
    this.endMinutes = AppConstants.bookingMinutes;
  }

  setValidatorType(bool: boolean, formCtrl: AbstractControl, validatorType?: string) {
    if (bool) {
      if (!validatorType) {
        formCtrl.setValidators([Validators.required]);
      } else if (validatorType.toLocaleLowerCase() === 'specialchar') {
        formCtrl.setValidators([ValidationService.isSpecialCharacters, Validators.required]);
      } else if (validatorType.toLocaleLowerCase() === 'custom') {
        formCtrl.setValidators([Validators.required, this.compareValidator, this.durationValidator]);
      } else if (validatorType.toLocaleLowerCase() === 'duration') {
        formCtrl.setValidators([Validators.required, this.durationValidator]);
      } else if (validatorType.toLocaleLowerCase() === 'minandmaxdate') {
        formCtrl.setValidators([Validators.required, this.validateMaxDate(this.minDate, this.maxDate)]);
      } else if (validatorType.toLocaleLowerCase() === 'validatehour') {
        formCtrl.setValidators([Validators.required]);
      } else {
        formCtrl.setValidators([Validators.required]);
      }
    } else {
      formCtrl.setValidators(null);
    }
    formCtrl.updateValueAndValidity();
  }

  changeTime() {
    const administeredDate = new Date(this.requestAppointmentForm.controls['administeredDate'].value);
    if (this.timeModel.startHour && this.timeModel.startMinutes) {
      const startHour = this.timeModel.startHour;
      this.requestAppointmentForm.controls.startHour.setValue(startHour);
      const startMinutes = startHour ? this.timeModel.startMinutes || '0' : '0';
      this.requestAppointmentForm.controls.startMinutes.setValue(startMinutes);
      const fromTime = new Date(administeredDate.getFullYear(), administeredDate.getMonth(),
        administeredDate.getDate(), parseInt(startHour, 0), parseInt(startMinutes, 0));
      this.requestAppointmentForm.controls['fromTime'].setValue(moment.utc(fromTime).local().format('YYYY-MM-DDTHH:mm:ss'));
      this.requestAppointmentForm.controls['fromTime'].setValidators([this.requireStartTime(startHour, startMinutes)]);
      this.requestAppointmentForm.controls['fromTime'].updateValueAndValidity();
    }
    if (this.timeModel.endHour && this.timeModel.endMinutes) {
      const endHour = this.timeModel.endHour;
      this.requestAppointmentForm.controls.endHour.setValue(endHour);
      const endMinutes = endHour ? this.timeModel.endMinutes || '0' : '0';
      this.requestAppointmentForm.controls.endMinutes.setValue(endMinutes);
      const toTime = new Date(administeredDate.getFullYear(), administeredDate.getMonth(),
        administeredDate.getDate(), parseInt(endHour, 0), parseInt(endMinutes, 0));
      this.requestAppointmentForm.controls['toTime'].setValue(moment.utc(toTime).local().format('YYYY-MM-DDTHH:mm:ss'));
      this.requestAppointmentForm.controls['toTime'].updateValueAndValidity();
    }
  }

  changeClosedTime() {
    if (this.closedTimeModel.startHour && this.closedTimeModel.endHour) {
      const startHour = this.closedTimeModel.startHour;
      const startMinutes = startHour ? this.closedTimeModel.startMinutes || '0' : '0';
      const endHour = this.closedTimeModel.endHour;
      const endMinutes = endHour ? this.closedTimeModel.endMinutes || '0' : '0';
      const closedDate = new Date(this.requestAppointmentForm.controls['administeredDate'].value);
      const fromTime = new Date(closedDate.getFullYear(), closedDate.getMonth(),
        closedDate.getDate(), parseInt(startHour, 0), parseInt(startMinutes, 0));
      const toTime = new Date(closedDate.getFullYear(), closedDate.getMonth(),
        closedDate.getDate(), parseInt(endHour, 0), parseInt(startMinutes, 0));
      this.requestAppointmentForm.controls['closedFromTime'].setValue(moment.utc(fromTime).local().format('YYYY-MM-DDTHH:mm:ss'));
      this.requestAppointmentForm.controls['closedToTime'].setValue(moment.utc(toTime).local().format('YYYY-MM-DDTHH:mm:ss'));

    }
  }

  requireStartTime(hourCtrl: string, minutes: string) {
    const str = 'required';
    return (input: FormControl) => {
      if (!hourCtrl || !minutes) {
        return { [str]: true };
      } else {
        return null;
      }
    };
  }

  validateMaxDate(minDate: Date, maxDate: Date, args = '') {
    const str = 'maxDateFluVaccine';
    if (moment.isDate(maxDate)) {
      return (input: FormControl) => {
        if (input.value) {
          if (moment.isDate(input.value)) {
            const dateObj = moment(input.value).toObject();
            if (dateObj.years > maxDate.getFullYear()) {
              return { [str]: true };
            } else if (dateObj.years === maxDate.getFullYear() && dateObj.months > maxDate.getMonth()) {
              return { [str]: true };
            } else if (dateObj.years === maxDate.getFullYear() && dateObj.months === maxDate.getMonth()
              && dateObj.date > maxDate.getDate()) {
              return { [str]: true };
            }
            if (dateObj.years < minDate.getFullYear()) {
              return { [str]: true };
            } else if (dateObj.years === minDate.getFullYear() && dateObj.months < minDate.getMonth()) {
              return { [str]: true };
            } else if (dateObj.years === minDate.getFullYear() && dateObj.months === minDate.getMonth()
              && dateObj.date < minDate.getDate()) {
              return { [str]: true };
            }
            return null;
          }
        }
      };
    }
  }

  compareValidator(control: AbstractControl) {
    const group = control.parent;
    if (group.controls['fromTime'].value && group.controls['toTime'].value) {
      const fromTime = new Date(group.controls['fromTime'].value);
      const toTime = new Date(group.controls['toTime'].value);
      if (fromTime >= toTime) {
        control.markAsTouched();
        return { 'invalidTime': true };
      }
    }
    return null;
  }

  durationValidator(control: AbstractControl) {
    const group = control.parent;
    if (group.controls['fromTime'].value && group.controls['toTime'].value) {
      const fromTime = moment(new Date(group.controls['fromTime'].value)).toObject();
      const toTime = moment(new Date(group.controls['toTime'].value)).toObject();
      if (fromTime.hours > toTime.hours) {
        return null;
      }
      const result = Math.abs((toTime.hours - fromTime.hours) * 60 + toTime.minutes - fromTime.minutes);
      const duration = <number>group.controls['duration'].value;
      if (result >= duration) {
        return null;
      }
      control.markAsTouched();
      return { 'invalidDuration': true };
    }
  }

  // check data for past
  isValidDateOfPast(formControl) {
    const selectedDate = formControl.value;
    const currenDateOfBirth = new Date();

    if (selectedDate < currenDateOfBirth) {
      return { 'invalidDateOfPast': true };
    }
    return null;
  }

  isValidData(data) {
    this.errorPattern.tripCountries = 0;

    if (data.tripCountries.length !== this.tripCountries.length) {
      this.errorPattern.tripCountries = 1;
    }
    if (this.errorPattern.tripCountries === 1) {
      return false;
    }
    return true;
  }

  onSelectOption(country, itemId, index) {
    if (this.tripCountries) {
      this.tripCountries[index].destinationTypeId = itemId;

    }
  }


  getCountryData(callback?) {
    this.requestAppointmentService.getUserCountryList().subscribe(
      (result) => {
        if (result) {
          this.countryData = result.json();
          callback(true);
        }
      }, error => callback(true));
  }

  /**
     * on change from date input event : format the date and set
     * @param event
     */

  onDepartDateChange(event) {
    this.requestAppointmentService.validateDateRange(this.requestAppointmentForm.controls['departDate'],
      this.requestAppointmentForm.controls['returnDate'], true);
  }

  /**
     * on change from date input event : format the date and set
     * @param event
  */
  onReturnDateChange(event) {
    this.requestAppointmentService.validateDateRange(this.requestAppointmentForm.controls['departDate'],
      this.requestAppointmentForm.controls['returnDate'], false);
  }

  changeInputDate(event: MdDatepickerInputEvent<any>, formName: string) {
    if (event) {
      if (formName) {
        if (this.requestAppointmentForm.controls.hasOwnProperty(formName)) {
          if (event.value instanceof Date && !isNaN(event.value.valueOf())) {
            this.requestAppointmentForm.controls[formName].setValue(event.value);
          }
        }
      }
    }
  }

  onBlurInputDate(event: FocusEvent, formName: string) {
    if (event) {
      if (formName) {
        if (this.requestAppointmentForm.controls.hasOwnProperty(formName)) {
          if (event.type === 'blur') {
            if ('Invalid Date'.indexOf(new Date(event.target['value']).toString()) > -1) {
              this.requestAppointmentForm.controls[formName].setValue(null);
            }
          }
        }
      }
    }
  }

  onChangeDestination(destination: any[], event) {
    if (destination.length > 0) {
      this.requestAppointmentForm.controls['destination'].setValidators([Validators.required]);
    } else {
      this.requestAppointmentForm.controls['destination'].setValidators(null);
    }
    let i = 0;
    const lens = destination.length;
    while (i < lens) {
      const index = this.tripCountries.findIndex(x => x.id === destination[i].id);
      destination[i].destinationTypeId = index > -1 ? this.tripCountries[index].destinationTypeId : null;
      i++;
    }
    this.tripCountries = destination;
  }

  onSubmit() {
    this.submitted = true;
    if (parseInt(this.requestAppointmentModel.bookingType.toString(), 0) === this.partyType.Blocked) {
      this.blockedBooking();
    } else {
      this.addNewBooking();
    }

  }

  addNewBooking(obj?: any) {
    this.requestAppointmentForm.updateValueAndValidity();
    if (this.requestAppointmentForm.valid) {
      const checkNullDestinationType = this.tripCountries.findIndex(x => x.destinationTypeId === null);
      if (checkNullDestinationType > -1) {
        return;
      }
      const paymentTermCtrl = <FormControl>this.requestAppointmentForm.controls['paymentTerm'];
      if (parseInt(this.requestAppointmentModel.bookingType.toString(), 0) === PartyType.FluVaccine) {
        paymentTermCtrl.enable();
        this.changeTime();
        this.requestAppointmentForm.controls['fromTime'].setValue(
          moment(this.requestAppointmentForm.value.fromTime).utc().format('YYYY-MM-DDTHH:mm:ss'));
        this.requestAppointmentForm.controls['toTime'].setValue(
          moment(this.requestAppointmentForm.value.toTime).utc().format('YYYY-MM-DDTHH:mm:ss'));
      } else {
        this.requestAppointmentForm.controls['fromTime'].disable();
        this.requestAppointmentForm.controls['toTime'].disable();
      }
      if (this.booking !== undefined && this.requestAppointmentForm.controls['bookingType'].value.toString() !== this.booking.toString()) {
        this.requestAppointmentForm.controls['isChangeType'].setValue(true);
      } else {
        this.requestAppointmentForm.controls['isChangeType'].setValue(false);
      }
      this.requestAppointmentForm.controls['centreId'].setValue(localStorage.getItem(AppConstants.localStorage.centreId));
      this.requestAppointmentForm.controls['travelDestination'].setValue(this.tripCountries);
      this.requestAppointmentForm.controls['listMembers'].setValue(this.requestAppointmentModel.listMembers);
      this.requestAppointmentForm.controls['staffs'].setValue(this.requestAppointmentModel.staffs);
      this.requestAppointmentForm.controls['isSaveFluBooking'].setValue(true);
      this.requestAppointmentService.addBookingCache(this.requestAppointmentForm.value).subscribe(
        (result) => {
          if (result) {
            this.router.navigate(['booking/list-member']);
          } else {
            this.requestAppointmentForm.controls['centre'].setValue(localStorage.getItem(AppConstants.localStorage.centreName));
          }
        }, error => {
          if (parseInt(this.requestAppointmentModel.bookingType.toString(), 0) === PartyType.FluVaccine) {
            paymentTermCtrl.disable();
            this.requestAppointmentForm.controls['fromTime'].enable();
            this.requestAppointmentForm.controls['toTime'].enable();
            this.requestAppointmentForm.controls['duration'].enable();
          }
          this.requestAppointmentForm.controls['centre'].setValue(localStorage.getItem(AppConstants.localStorage.centreName));
        }
      );
    }
  }
  disableControl() {
    this.disableList.forEach(name => {
      if (this.requestAppointmentForm.controls.hasOwnProperty(name)) {
        this.requestAppointmentForm.controls[name].disable();
      }
    });
  }

  blockedBooking() {
    this.disableControl();
    if (this.requestAppointmentForm.valid) {
      this.requestAppointmentService.addBooking(this.requestAppointmentForm.value).subscribe(
        result => {
          if (result) {
            this.router.navigate(['booking/manage-booking']);
          }
        }
      );
      this.router.navigate(['booking/manage-booking']);
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/request-appointment/request-appointment.component.ts